// extracted by mini-css-extract-plugin
module.exports = {"oneBuyer":"style_oneBuyer__Ravjz","bestTop":"style_bestTop__MP0vs","topBuyerImage":"style_topBuyerImage__mW_x9","buttonStyle":"style_buttonStyle__MimIe"};